// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"checkEmailPage_parentContainer__3GSyV","childContainer":"checkEmailPage_childContainer__3TaAh","logo":"checkEmailPage_logo__1qg2m"};